import alertify from 'alertifyjs';
import { I18n } from 'react-redux-i18n';

export function getCommentShareUrl(commentId) {
    if (!commentId || typeof window === 'undefined') {
        return '';
    }
    const url = new URL('/comment', window.location.origin);
    url.searchParams.set('id', String(commentId));
    return url.toString();
}

function canUseNativeShare() {
    return typeof navigator !== 'undefined'
        && typeof navigator.share === 'function'
        && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

function copyTextFallback(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    try {
        return document.execCommand('copy');
    } catch {
        return false;
    } finally {
        document.body.removeChild(textarea);
    }
}

async function copyToClipboard(text) {
    if (navigator.clipboard?.writeText) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch {
            // fall through to execCommand
        }
    }
    return copyTextFallback(text);
}

function notifyShare(message, isError = false) {
    alertify.set('notifier', 'delay', 4);
    alertify.set('notifier', 'position', 'top-right');
    if (isError) {
        alertify.error(message);
    } else {
        alertify.success(message);
    }
}

export async function shareComment(item) {
    if (!item?.id) {
        notifyShare(I18n.t('share_failed'), true);
        return;
    }

    const url = getCommentShareUrl(item.id);
    const text = item.comment?.trim() || '';
    const title = item.user?.username
        ? `${item.user.username} — EbiTrade`
        : 'EbiTrade';

    if (canUseNativeShare()) {
        try {
            await navigator.share({ title, text, url });
            return;
        } catch (err) {
            if (err?.name === 'AbortError') {
                return;
            }
        }
    }

    const copied = await copyToClipboard(url);
    if (copied) {
        notifyShare(I18n.t('share_link_copied'));
        return;
    }

    if (typeof window.prompt === 'function') {
        window.prompt(I18n.t('share_copy_prompt'), url);
        return;
    }

    notifyShare(I18n.t('share_failed'), true);
}
